module.exports = {"tal":"Tag Access List","id":"Id","member":"Member","tag":"tag","name":"Name"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/no/tag.json
// module id = FLft
// module chunks = 23